import React from 'react'
import Header_Orion from '../LayoutMain_Orion/Header_Orion'

export default function DashboardMain_Orion(props) {
  return (
    <>
      <Header_Orion />
      {props.children}
    </>
  )
}
